import { render, staticRenderFns } from "./DigitalContract.vue?vue&type=template&id=0fc56dad"
import script from "./DigitalContract.vue?vue&type=script&lang=js"
export * from "./DigitalContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports